(function ($) {
    EqUI.cards = {};

    // Init
    EqUI.cards.init = function() {

    };

    // Update
    EqUI.cards.update = function() {
        
    };

    $(document).ready(function() {
        // Init
        EqUI.cards.init();

        // Update
        EqUI.cards.update();
    });
}( jQuery ));